export { DetailsPageHeader } from './DetailsPageHeader';
